import { ReactNode } from "react";
import { Home24Filled, Games24Filled, PeopleCommunity24Filled, Form24Filled, TextFontInfo24Filled, Question24Filled, ContactCard24Filled } from '@fluentui/react-icons';

export interface NavigationLink {
	display: string,
	target: string,
	icon?: ReactNode
}

const NavbarLinks: NavigationLink[] = [
	{
		display: "Home",
		target: "/",
		icon: <Home24Filled />
	},
	{
		display: "Games",
		target: "/games",
		icon: <Games24Filled />
	},
	{
		display: "Players",
		target: "/players",
		icon: <PeopleCommunity24Filled />
	},
	{
		display: "Reviews",
		target: "/reviews",
		icon: <Form24Filled />
	},
	{
		display: "About",
		target: "/about",
		icon: <TextFontInfo24Filled />
	},
	{
		display: "FAQ",
		target: "/faq",
		icon: <Question24Filled />
	},
	{
		display: "Contact",
		target: "/contact",
		icon: <ContactCard24Filled />
	}
];

export default NavbarLinks;
